/**
 * Funnel Resource - API client for funnel navigation and session management
 */
/**
 * Funnel action types enum
 *
 * Special types:
 * - DIRECT_NAVIGATION: Bypasses step conditions, navigates directly to targetStepId
 * - BACK_NAVIGATION: Similar to direct_navigation, used for backward navigation
 *
 * Common types (for logging/tracking):
 * - These are commonly used action types that align with funnel orchestrator conditions
 * - Navigation logic is based on step conditions.from, action types are primarily for analytics
 */
export var FunnelActionType;
(function (FunnelActionType) {
    // Special navigation types (bypass step conditions)
    FunnelActionType["DIRECT_NAVIGATION"] = "direct_navigation";
    FunnelActionType["BACK_NAVIGATION"] = "back_navigation";
    // User interaction types
    FunnelActionType["CONTINUE_CLICKED"] = "continue_clicked";
    FunnelActionType["BUTTON_CLICK"] = "button_click";
    FunnelActionType["FORM_SUBMIT"] = "form_submit";
    // Payment actions
    FunnelActionType["PAYMENT_SUCCESS"] = "payment_success";
    FunnelActionType["PAYMENT_FAILED"] = "payment_failed";
    // Offer actions
    FunnelActionType["OFFER_ACCEPTED"] = "offer_accepted";
    FunnelActionType["OFFER_DECLINED"] = "offer_declined";
    // Cart actions
    FunnelActionType["CART_UPDATED"] = "cart_updated";
    FunnelActionType["CART_ITEM_ADDED"] = "cart_item_added";
    // Generic/custom actions
    FunnelActionType["CUSTOM"] = "custom";
})(FunnelActionType || (FunnelActionType = {}));
export class FunnelResource {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    /**
     * Initialize a funnel session
     */
    async initialize(request) {
        return this.apiClient.post('/api/v1/funnel/initialize', request);
    }
    /**
     * Navigate to next step in funnel
     */
    async navigate(request) {
        return this.apiClient.post('/api/v1/funnel/navigate', request);
    }
    /**
     * Update funnel context
     */
    async updateContext(sessionId, request) {
        return this.apiClient.patch(`/api/v1/funnel/context/${sessionId}`, request);
    }
    /**
     * End funnel session
     */
    async endSession(sessionId) {
        return this.apiClient.delete(`/api/v1/funnel/session/${sessionId}`);
    }
    /**
     * Get funnel session by ID
     * @param sessionId - The session ID to fetch
     * @param currentUrl - Optional current URL for session synchronization on page load
     */
    async getSession(sessionId, currentUrl, includeDebugData) {
        const params = new URLSearchParams();
        if (currentUrl) {
            params.append('currentUrl', currentUrl);
        }
        if (includeDebugData) {
            params.append('includeDebugData', 'true');
        }
        const url = `/api/v1/funnel/session/${sessionId}${params.toString() ? `?${params}` : ''}`;
        return this.apiClient.get(url);
    }
}
